import {
  createRootRoute,
  Outlet,
  useNavigate,
  useRouterState,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import LayerProvider from "../Components/Map/LayerProvider";
import Sidebar from "../Components/ui/Sidebar";

export const Route = createRootRoute({
  component: () => {
    const routerState = useRouterState();
    const navigate = useNavigate();
    if (routerState.location.pathname === "/") navigate({ to: "/Home" });
    return (
      <>
        <Sidebar />
        <div className="m-6">
          <LayerProvider>
            <Outlet />
          </LayerProvider>
        </div>
        <TanStackRouterDevtools />
      </>
    );
  },
});
